import React, { Component } from 'react'
import reactCSS from 'reactcss'
import { SketchPicker,TwitterPicker } from 'react-color'

type Color = {
    color:{
        r:string,
        g:string,
        b:string,
        a:string
    }
 
  };
export type Props = {
    changeColor:(color:Color) => void
 
  };
  
class SketchExample extends Component<Props> {

  state = {
    displayColorPicker: false,
    color: {
      r: '0',
      g: '0',
      b: '0',
      a: '1',
    },
  };

  handleClick = () => {
    this.setState({ displayColorPicker: !this.state.displayColorPicker })
  };

  handleClose = () => {
    this.setState({ displayColorPicker: false })
  };

  handleChange = (color) => {
    this.setState({ color: color.rgb })
    this.props.changeColor(color.rgb)
    console.log(color.rgb)
  };

  render() {
    

    const styles = reactCSS({
      'default': {
        color: {
          width: '18px',
          height: '18px',
          borderRadius: '2px',
          background: `rgba(${ this.state.color.r }, ${ this.state.color.g }, ${ this.state.color.b }, ${ this.state.color.a })`,
        },
        swatch: {
          padding: '2px',
          background: '#fff',
          borderRadius: '1px',
          boxShadow: '0 0 0 1px rgba(0,0,0,.1)',
          display: 'inline-block',
          cursor: 'pointer',
        },
        popover: {
          position: 'absolute',
          zIndex: '2',
          right:'0'
        },
        // cover: {
        //     position: 'fixed',
        //     top: '0px',
        //     right: '0px',
        //     bottom: '0px',
        //     left: '0px',
        //     scale:1,
        //     backgroundColor:'red'
        //   },
      },
    });

    return (
      <div>
        <div style={ styles.swatch } onClick={ this.handleClick }>
          <div style={ styles.color } />
        </div>
        { this.state.displayColorPicker ? <div className={'cp-popover'} onClick={ this.handleClose }>
          <div className={'cp-cover'} onClick={ this.handleClose }/>
          <TwitterPicker triangle="none" color={ this.state.color } onChange={ this.handleChange } />
        </div> : null }

      </div>
    )
  }
}

export default SketchExample